import React from 'react';
import { AutoAwesome, Edit } from '@mui/icons-material';
import './PromptAutomatorHeader.css';

function PromptAutomatorHeader({ selectedTask, onEditTask, onGenerate, canGenerate, loadingTasks }) {
  if (loadingTasks) {
    return (
      <div className="prompt-automator-header">
        <div className="header-content">
          <div className="header-skeleton">
            <div className="header-skeleton-photo"></div>
            <div className="header-skeleton-info">
              <div className="header-skeleton-title"></div>
              <div className="header-skeleton-description"></div>
              <div className="header-skeleton-count"></div>
            </div>
          </div>
          <div className="header-actions">
            <button 
              onClick={onGenerate}
              disabled={true}
              className="header-generate-btn"
              title="Loading..."
            >
              <AutoAwesome className="generate-btn-icon" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!selectedTask) {
    return (
      <div className="prompt-automator-header">
        <div className="header-content">
          <div className="header-empty">
            <div className="header-empty__message">Select a task to view details</div>
          </div>
          <div className="header-actions">
            <button 
              onClick={onGenerate}
              disabled={true}
              className="header-generate-btn"
              title="Select a task first"
            >
              <AutoAwesome className="generate-btn-icon" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  const handleEditClick = () => {
    if (onEditTask) {
      onEditTask(selectedTask);
    }
  };

  const getTotalPromptsCount = (task) => {
    if (!task.prompts) return 0;
    
    let total = 0;
    Object.entries(task.prompts).forEach(([key, value]) => {
      if (key === 'promptTemplate' || key === 'personalityTemplate') {
        if (typeof value === 'string' && value.length > 0) {
          total += 1;
        }
      } else {
        if (Array.isArray(value)) {
          total += value.length;
        }
      }
    });
    
    return total;
  };

  return (
    <div className="prompt-automator-header">
      <div className="header-content">
        <div className="header-photo" onClick={handleEditClick}>
          {selectedTask.photoUrl ? (
            <img 
              src={selectedTask.photoUrl} 
              alt={selectedTask.name}
              className="header-photo__image"
            />
          ) : (
            <div className="header-photo__placeholder">
              <AutoAwesome className="header-photo__icon" />
            </div>
          )}
          <div className="photo-edit-overlay">
            <Edit />
            <span>Edit</span>
          </div>
        </div>
        
        <div className="header-info">
          <h1 className="header-title">{selectedTask.name}</h1>
          {selectedTask.description && (
            <p className="header-description">{selectedTask.description}</p>
          )}
          <div className="header-prompt-count">
            {getTotalPromptsCount(selectedTask)} prompt{getTotalPromptsCount(selectedTask) !== 1 ? 's' : ''}
          </div>
        </div>
        
        <div className="header-actions">
          <button 
            onClick={onGenerate}
            disabled={!canGenerate}
            className="header-generate-btn"
            title="Generate a random prompt using current template and parameters"
          >
            <AutoAwesome className="generate-btn-icon" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default PromptAutomatorHeader;